import { GTChangeType } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const changeTypeMessages = defineMessages({
  [GTChangeType.RouteServiceRouteChanged]: {
    id: 'changes.type.routeChanged',
    defaultMessage: 'Route changed'
  },
  [GTChangeType.RouteServiceItineraryChanged]: {
    id: 'changes.type.itineraryChanged',
    defaultMessage: 'Itinerary changed'
  },
  [GTChangeType.RouteServiceDeactivated]: {
    id: 'changes.type.serviceDeactivated',
    defaultMessage: 'Service deactivated'
  },
  [GTChangeType.TripCancelled]: {
    id: 'changes.type.tripCancelled',
    defaultMessage: 'Trip cancelled'
  },
  [GTChangeType.ChangeRouteServicesRoute]: {
    id: 'changes.type.changeRoute',
    defaultMessage: 'Change route'
  },
  [GTChangeType.ChangeRouteServiceItinerary]: {
    id: 'changes.type.changeItinerary',
    defaultMessage: 'Change itinerary'
  },
  [GTChangeType.RouteServiceVehicleChanged]: {
    id: 'changes.type.serviceVehicleChanged',
    defaultMessage: 'Service vehicle changed'
  },
  [GTChangeType.TripVehicleChanged]: {
    id: 'changes.type.tripVehicleChanged',
    defaultMessage: 'Trip vehicle changed'
  },
  [GTChangeType.TripItineraryChanged]: {
    id: 'changes.type.tripItineraryChanged',
    defaultMessage: 'Trip itinerary changed'
  },
  [GTChangeType.TripRouteChanged]: {
    id: 'changes.type.tripRouteChanged',
    defaultMessage: 'Trip route changed'
  },
  [GTChangeType.RouteServiceActivePeriodChanged]: {
    id: 'changes.type.routeServiceActivePeriodChanged',
    defaultMessage: 'Service edit active period'
  }
})
